import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
}

const QuestionsSubForm: React.FC<HeaderProps> = ({
  control,
  errors,
  watch,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "sub_data",
  });

  useEffect(() => {
    if (!watch("sub_data") || watch("sub_data").length === 0) {
      setValue("sub_data", [{ name: "" }]);
    }
  }, [watch, setValue]);

  const addRemoveButtons = (index: number): React.ReactNode => {
    return (
      <>
        <span className="icon">
          {index === fields.length - 1 && (
            <i
              className="fa fa-plus has-text-link smart-cursor"
              onClick={() => append({})}
            ></i>
          )}
        </span>
        <span className="icon">
          {" "}
          {index > 0 && (
            <i
              className="fa fa-trash has-text-danger smart-cursor"
              onClick={() => remove(index)}
            ></i>
          )}
        </span>
      </>
    );
  };

  const getElements = (index: number) => {
    const elements: SdsFormElementProps[] = [
      {
        type: "LABEL",
        width: 1,
        class_name: "has-text-centered p-2",
        name: `sno.${index}`,
        labelComponent: <strong>{index + 1}.</strong>,
      },
      {
        type: "TEXT_BOX",
        width: 5,
        name: `sub_data.${index}.english`,
        element: {
          //  size: "small",
          // isHorizontal: true,
        },
      },
      {
        type: "TEXT_BOX",
        width: 5,
        name: `sub_data.${index}.hindi`,
        element: {
          // size: "small",
          // isHorizontal: true,
        },
      },
      {
        type: "LABEL",
        width: 1,
        class_name: "has-text-centered p-2",
        name: "addbuttons",
        labelComponent: addRemoveButtons(index),
      },
    ];
    return elements;
  };

  return (
    <div className="sd-hims-input sd-hims-batch-form">
      <div className="columns is-gapless mb-0">
        <div className="column is-1 has-text-weight-bold sd-hims-input label">S.No</div>
        <div className="column is-5 has-text-weight-bold sd-hims-input label">Option (English)</div>
        <div className="column is-5 has-text-weight-bold sd-hims-input label">Option (Hindi)</div>
        <div className="column is-1"></div>
      </div>
      {fields.map((field, index) => (
        <SdsForm
          elements={getElements(index)}
          errors={errors}
          control={control}
          className="mb-1"
        />
      ))}
    </div>
  );
};

export default QuestionsSubForm;
